import { useFocusable as O } from "./PFRGBC2K.js";
import { createHook as h, forwardRef as q, createElement as x } from "./LMDWO4NN.js";
import { useMetadataProps as Y, useEvent as w, useMergeRefs as j } from "./ABQUS43J.js";
import { __objRest as m, __spreadProps as H, __spreadValues as T } from "./3YLGPPWQ.js";
import { isButton as p, isTextField as L } from "../../../../../../@ariakit_core@0.4.15/node_modules/@ariakit/core/esm/__chunks/DTR5TSDJ.js";
import { isSelfTarget as V, queueBeforeEvent as z, fireClickEvent as _ } from "../../../../../../@ariakit_core@0.4.15/node_modules/@ariakit/core/esm/utils/events.js";
import { disabledFromProps as G } from "../../../../../../@ariakit_core@0.4.15/node_modules/@ariakit/core/esm/__chunks/PBFD2E7P.js";
import { isFirefox as J } from "../../../../../../@ariakit_core@0.4.15/node_modules/@ariakit/core/esm/__chunks/QAGXQEUG.js";
import { useRef as C, useState as D, useEffect as Q } from "react";
var W = "button";
function M(o) {
  if (!o.isTrusted) return !1;
  const t = o.currentTarget;
  return o.key === "Enter" ? p(t) || t.tagName === "SUMMARY" || t.tagName === "A" : o.key === " " ? p(t) || t.tagName === "SUMMARY" || t.tagName === "INPUT" || t.tagName === "SELECT" : !1;
}
var X = Symbol("command"), Z = h(
  function(t) {
    var s = t, { clickOnEnter: d = !0, clickOnSpace: u = !0 } = s, r = m(s, ["clickOnEnter", "clickOnSpace"]);
    const c = C(null), [R, K] = D(!1);
    Q(() => {
      c.current && K(p(c.current));
    }, []);
    const [U, k] = D(!1), f = C(!1), y = G(r), [E, A] = Y(r, X, !0), P = r.onKeyDown, B = w((e) => {
      P == null || P(e);
      const n = e.currentTarget;
      if (e.defaultPrevented || E || y || !V(e) || L(n) || n.isContentEditable) return;
      const a = d && e.key === "Enter", i = u && e.key === " ", v = e.key === "Enter" && !d, l = e.key === " " && !u;
      if (v || l) {
        e.preventDefault();
        return;
      }
      if (a || i) {
        const S = M(e);
        if (a) {
          if (!S) {
            e.preventDefault();
            const b = e, { view: $ } = b, I = m(b, ["view"]), N = () => _(n, I);
            J() ? z(n, "keyup", N) : queueMicrotask(N);
          }
        } else i && (f.current = !0, S || (e.preventDefault(), k(!0)));
      }
    }), g = r.onKeyUp, F = w((e) => {
      if (g == null || g(e), e.defaultPrevented || E || y || e.metaKey) return;
      const n = u && e.key === " ";
      if (f.current && n && (f.current = !1, !M(e))) {
        e.preventDefault(), k(!1);
        const a = e.currentTarget, i = e, { view: v } = i, l = m(i, ["view"]);
        queueMicrotask(() => _(a, l));
      }
    });
    return r = H(T(T({
      "data-active": U || void 0,
      type: R ? "button" : void 0
    }, A), r), {
      ref: j(c, r.ref),
      onKeyDown: B,
      onKeyUp: F
    }), r = O(r), r;
  }
);
q(function(t) {
  const s = Z(t);
  return x(W, s);
});
export {
  Z as useCommand
};
//# sourceMappingURL=2RSXSRCN.js.map
